/* tslint:disable */
/* eslint-disable */
/**
 * Nola出版 ユーザー向けAPI
 * Nola出版 ユーザー向けAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// import
import { API } from "aws-amplify"


// ====== Models (start) ======
/**
 * 
 * @export
 * @interface AcceptTermsRequest
 */
export interface AcceptTermsRequest {
    /**
     * 同意したかどうか
     * @type {boolean}
     * @memberof AcceptTermsRequest
     */
    accepted: boolean;
    /**
     * 同意対象のバージョン
     * @type {string}
     * @memberof AcceptTermsRequest
     */
    termsVersion: string;
}

/**
 * プロフィール情報
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 名前
     * @type {string}
     * @memberof Account
     */
    name: string;
    /**
     * 画像ファイルのパス
     * @type {string}
     * @memberof Account
     */
    avaterImage?: string;
    /**
     * 確認済みのチュートリアルのバージョン
     * @type {number}
     * @memberof Account
     */
    confirmedTutorial?: number;
}

/**
 * 住所
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 国
     * @type {string}
     * @memberof Address
     */
    country?: string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof Address
     */
    postalCode?: string;
    /**
     * 都道府県
     * @type {string}
     * @memberof Address
     */
    state?: string;
    /**
     * 市区町村
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 番地
     * @type {string}
     * @memberof Address
     */
    town?: string;
    /**
     * 建物1
     * @type {string}
     * @memberof Address
     */
    line1?: string;
    /**
     * 建物2
     * @type {string}
     * @memberof Address
     */
    line2?: string;
}

/**
 * お知らせ項目
 * @export
 * @interface Announcement
 */
export interface Announcement {
    /**
     * タイトル
     * @type {string}
     * @memberof Announcement
     */
    title: string;
    /**
     * 本文
     * @type {string}
     * @memberof Announcement
     */
    text: string;
    /**
     * 掲載時刻
     * @type {string}
     * @memberof Announcement
     */
    start?: string;
}

/**
 * 共通エラー情報
 * @export
 * @interface ApiError
 */
export interface ApiError {
    /**
     * 
     * @type {ErrorCode}
     * @memberof ApiError
     */
    code: ErrorCode;
    /**
     * メッセージ
     * @type {string}
     * @memberof ApiError
     */
    message?: string;
}

/**
 * API情報
 * @export
 * @interface ApiResult
 */
export interface ApiResult {
    /**
     * メッセージ
     * @type {string}
     * @memberof ApiResult
     */
    message?: string;
}

/**
 * 著者情報
 * @export
 * @interface Author
 */
export interface Author {
    /**
     * 著者ID
     * @type {string}
     * @memberof Author
     */
    id: string;
    /**
     * 名前
     * @type {string}
     * @memberof Author
     */
    name: string;
    /**
     * メモ
     * @type {string}
     * @memberof Author
     */
    memo?: string;
    /**
     * 名前カナ
     * @type {string}
     * @memberof Author
     */
    nameKana: string;
    /**
     * 名前ローマ字
     * @type {string}
     * @memberof Author
     */
    nameRomanAlphabet: string;
    /**
     * 画像のパス
     * @type {string}
     * @memberof Author
     */
    imageFileName?: string;
}

/**
 * 著者情報
 * @export
 * @interface AuthorCreateRequest
 */
export interface AuthorCreateRequest {
    /**
     * 名前
     * @type {string}
     * @memberof AuthorCreateRequest
     */
    name: string;
    /**
     * 名前（かな）
     * @type {string}
     * @memberof AuthorCreateRequest
     */
    nameKana: string;
    /**
     * 名前（ローマ字）
     * @type {string}
     * @memberof AuthorCreateRequest
     */
    nameRomanAlphabet: string;
    /**
     * メモ
     * @type {string}
     * @memberof AuthorCreateRequest
     */
    memo: string;
    /**
     * 画像ファイルのパス
     * @type {string}
     * @memberof AuthorCreateRequest
     */
    imageFileName?: string;
}

/**
 * 銀行口座
 * @export
 * @interface BankAccount
 */
export interface BankAccount {
    /**
     * ID
     * @type {string}
     * @memberof BankAccount
     */
    id: string;
    /**
     * 銀行コード(4桁)
     * @type {string}
     * @memberof BankAccount
     */
    bankCode: string;
    /**
     * 支店コード(4桁)
     * @type {string}
     * @memberof BankAccount
     */
    branchCode: string;
    /**
     * 銀行名
     * @type {string}
     * @memberof BankAccount
     */
    bankName?: string;
    /**
     * 口座番号
     * @type {string}
     * @memberof BankAccount
     */
    accountNumber: string;
    /**
     * 口座名義
     * @type {string}
     * @memberof BankAccount
     */
    accountHolderName: string;
    /**
     * 規定の支払い先か
     * @type {boolean}
     * @memberof BankAccount
     */
    defaultForCurrency: boolean;
}

/**
 * 書籍情報
 * @export
 * @interface Book
 */
export interface Book {
    /**
     * 書籍ID
     * @type {string}
     * @memberof Book
     */
    id: string;
    /**
     * タイトル
     * @type {string}
     * @memberof Book
     */
    title: string;
    /**
     * タイトル(ひらかな)
     * @type {string}
     * @memberof Book
     */
    titleKana: string;
    /**
     * タイトル(ローマ字)
     * @type {string}
     * @memberof Book
     */
    titleRomanAlphabet?: string;
    /**
     * サブタイトル
     * @type {string}
     * @memberof Book
     */
    subtitle?: string;
    /**
     * サブタイトル(かな)
     * @type {string}
     * @memberof Book
     */
    subtitleKana?: string;
    /**
     * サブタイトル(ローマ字)
     * @type {string}
     * @memberof Book
     */
    subtitleRomanAlphabet?: string;
    /**
     * シリーズタイトル
     * @type {string}
     * @memberof Book
     */
    seriesTitle?: string;
    /**
     * シリーズタイトル(かな)
     * @type {string}
     * @memberof Book
     */
    seriesTitleKana?: string;
    /**
     * シリーズタイトル(ローマ字)
     * @type {string}
     * @memberof Book
     */
    seriesTitleRomanAlphabet?: string;
    /**
     * 巻数
     * @type {number}
     * @memberof Book
     */
    numberOfVolumes?: number;
    /**
     * 説明文・あらすじ
     * @type {string}
     * @memberof Book
     */
    description: string;
    /**
     * 著者ID
     * @type {string}
     * @memberof Book
     */
    authorId?: string;
    /**
     * 
     * @type {Author}
     * @memberof Book
     */
    author?: Author;
    /**
     * 出版依頼申請日時
     * @type {string}
     * @memberof Book
     */
    requestDate: string;
    /**
     * 販売日
     * @type {string}
     * @memberof Book
     */
    publishDate?: string;
    /**
     * 販売価格
     * @type {number}
     * @memberof Book
     */
    price: number;
    /**
     * サムネイルのファイル名
     * @type {string}
     * @memberof Book
     */
    thumbnailFileName?: string;
    /**
     * 
     * @type {Array<Category>}
     * @memberof Book
     */
    categories?: Array<Category>;
    /**
     * 
     * @type {Array<Array<CategoryComic>>}
     * @memberof Book
     */
    categoryList?: Array<Array<CategoryComic>>;
    /**
     * 
     * @type {XRated}
     * @memberof Book
     */
    xRated: XRated;
    /**
     * 
     * @type {CompleteFlag}
     * @memberof Book
     */
    completeFlag?: CompleteFlag;
    /**
     * 入稿データフォーマット
     * @type {string}
     * @memberof Book
     */
    seriesFormat?: string;
    /**
     * 
     * @type {BookPaperBookOptions}
     * @memberof Book
     */
    paperBookOptions?: BookPaperBookOptions;
    /**
     * 出版先ストア一覧
     * @type {Array<number>}
     * @memberof Book
     */
    storeIds: Array<number>;
    /**
     * 
     * @type {PublishStatus}
     * @memberof Book
     */
    publishStatus: PublishStatus;
    /**
     * 
     * @type {BookKind}
     * @memberof Book
     */
    kind?: BookKind;
}

/**
 * 書籍作成リクエスト情報
 * @export
 * @interface BookCreateRequest
 */
export interface BookCreateRequest {
    /**
     * ワークスペースID
     * @type {string}
     * @memberof BookCreateRequest
     */
    workspaceId: string;
}

/**
 * 書籍の区分
 * @export
 * @enum {string}
 */
export enum BookKind {
    Novel = 'novel',
    Comic = 'comic'
}

/**
 * 紙書籍の出版オプション
 * @export
 * @interface BookPaperBookOptions
 */
export interface BookPaperBookOptions {
    /**
     * 
     * @type {number}
     * @memberof BookPaperBookOptions
     */
    pages?: number;
    /**
     * 
     * @type {string}
     * @memberof BookPaperBookOptions
     */
    publishDate?: string;
    /**
     * 
     * @type {number}
     * @memberof BookPaperBookOptions
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof BookPaperBookOptions
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof BookPaperBookOptions
     */
    labelKana?: string;
    /**
     * 
     * @type {string}
     * @memberof BookPaperBookOptions
     */
    labelRomanAlphabet?: string;
    /**
     * 
     * @type {string}
     * @memberof BookPaperBookOptions
     */
    isbn?: string;
}

/**
 * ストア毎書籍データ
 * @export
 * @interface BookPerStoreInfo
 */
export interface BookPerStoreInfo {
    /**
     * ストアID
     * @type {number}
     * @memberof BookPerStoreInfo
     */
    storeId: number;
    /**
     * 販売URL
     * @type {string}
     * @memberof BookPerStoreInfo
     */
    sellingURL: string;
    /**
     * ストア内でのユニークなID
     * @type {string}
     * @memberof BookPerStoreInfo
     */
    withinStoreId: string;
    /**
     * 
     * @type {PublishStatus}
     * @memberof BookPerStoreInfo
     */
    publishStatus: PublishStatus;
}

/**
 * ストア
 * @export
 * @interface BookStore
 */
export interface BookStore {
    /**
     * ストアID
     * @type {number}
     * @memberof BookStore
     */
    id: number;
    /**
     * ストア名
     * @type {string}
     * @memberof BookStore
     */
    name: string;
    /**
     * ストアURL
     * @type {string}
     * @memberof BookStore
     */
    url: string;
    /**
     * 順序
     * @type {number}
     * @memberof BookStore
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof BookStore
     */
    withinStoreIdName?: string;
    /**
     * 販売URL入力可能かどうか
     * @type {boolean}
     * @memberof BookStore
     */
    enableInputSellingUrl?: boolean;
    /**
     * ステータス管理するかどうか
     * @type {boolean}
     * @memberof BookStore
     */
    manageStatus?: boolean;
}

/**
 * Epub生成リクエスト
 * @export
 * @interface BucketObjectRequest
 */
export interface BucketObjectRequest {
    /**
     * 
     * @type {BucketOperation}
     * @memberof BucketObjectRequest
     */
    operation: BucketOperation;
    /**
     * 
     * @type {UserDataKind}
     * @memberof BucketObjectRequest
     */
    kind: UserDataKind;
    /**
     * キー（kind毎）
     * @type {string}
     * @memberof BucketObjectRequest
     */
    key?: string;
}

/**
 * S3バケットの操作
 * @export
 * @enum {string}
 */
export enum BucketOperation {
    GetObject = 'getObject',
    PutObject = 'putObject'
}

/**
 * S3バケットのアクセスURL
 * @export
 * @interface BucketURL
 */
export interface BucketURL {
    /**
     * URL
     * @type {string}
     * @memberof BucketURL
     */
    url?: string | null;
}

/**
 * ビジネス情報
 * @export
 * @interface BusinessProfile
 */
export interface BusinessProfile {
    /**
     * MCC
     * @type {string}
     * @memberof BusinessProfile
     */
    mcc: string;
    /**
     * 商品の説明
     * @type {string}
     * @memberof BusinessProfile
     */
    productDescription: string;
    /**
     * URL
     * @type {string}
     * @memberof BusinessProfile
     */
    url: string;
}

/**
 * カテゴリ
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * カテゴリID
     * @type {number}
     * @memberof Category
     */
    id: number;
    /**
     * カテゴリ名
     * @type {string}
     * @memberof Category
     */
    name: string;
    /**
     * グループ
     * @type {string}
     * @memberof Category
     */
    group: string;
    /**
     * 祖先カテゴリ（ルートから順番）
     * @type {Array<CategoryAncestors>}
     * @memberof Category
     */
    ancestors?: Array<CategoryAncestors>;
}

/**
 * 
 * @export
 * @interface CategoryAncestors
 */
export interface CategoryAncestors {
    /**
     * カテゴリID
     * @type {number}
     * @memberof CategoryAncestors
     */
    id: number;
    /**
     * カテゴリ名
     * @type {string}
     * @memberof CategoryAncestors
     */
    name: string;
}

/**
 * カテゴリ(漫画)
 * @export
 * @interface CategoryComic
 */
export interface CategoryComic {
    /**
     * カテゴリID
     * @type {number}
     * @memberof CategoryComic
     */
    id: number;
    /**
     * カテゴリ名
     * @type {string}
     * @memberof CategoryComic
     */
    name: string;
}

/**
 * カテゴリ漫画
 * @export
 * @interface CategoryComicResult
 */
export interface CategoryComicResult {
    /**
     * カテゴリグループ一覧
     * @type {Array<Array<CategoryNode>>}
     * @memberof CategoryComicResult
     */
    items: Array<Array<CategoryNode>>;
}

/**
 * カテゴリツリーグループ
 * @export
 * @interface CategoryGroup
 */
export interface CategoryGroup {
    /**
     * グループ
     * @type {string}
     * @memberof CategoryGroup
     */
    group: string;
    /**
     * カテゴリ一覧
     * @type {Array<CategoryNode>}
     * @memberof CategoryGroup
     */
    children: Array<CategoryNode>;
}

/**
 * カテゴリノード
 * @export
 * @interface CategoryNode
 */
export interface CategoryNode {
    /**
     * カテゴリID
     * @type {number}
     * @memberof CategoryNode
     */
    id: number;
    /**
     * カテゴリ名
     * @type {string}
     * @memberof CategoryNode
     */
    name: string;
    /**
     * 子カテゴリ一覧
     * @type {Array<CategoryNode>}
     * @memberof CategoryNode
     */
    children?: Array<CategoryNode>;
}

/**
 * カテゴリツリー
 * @export
 * @interface CategoryTreeResult
 */
export interface CategoryTreeResult {
    /**
     * カテゴリグループ一覧
     * @type {Array<CategoryGroup>}
     * @memberof CategoryTreeResult
     */
    items: Array<CategoryGroup>;
}

/**
 * 出版申請決済リクエスト
 * @export
 * @interface ChargeForPublishRequest
 */
export interface ChargeForPublishRequest {
    /**
     * 書籍ID
     * @type {string}
     * @memberof ChargeForPublishRequest
     */
    bookId: string;
    /**
     * ペイメントメソッドID
     * @type {string}
     * @memberof ChargeForPublishRequest
     */
    paymentMethodId?: string;
}

/**
 * 出版申請決済レスポンス
 * @export
 * @interface ChargeForPublishResult
 */
export interface ChargeForPublishResult {
    /**
     * 受付したかどうか？
     * @type {boolean}
     * @memberof ChargeForPublishResult
     */
    accepted?: boolean;
}

/**
 * 課金情報
 * @export
 * @interface ChargeInfo
 */
export interface ChargeInfo {
    /**
     * 
     * @type {ChargeInfoSummary}
     * @memberof ChargeInfo
     */
    summary: ChargeInfoSummary;
    /**
     * 詳細情報
     * @type {Array<ChargeInfoItems>}
     * @memberof ChargeInfo
     */
    items: Array<ChargeInfoItems>;
}

/**
 * 
 * @export
 * @interface ChargeInfoItems
 */
export interface ChargeInfoItems {
    /**
     * 項目名
     * @type {string}
     * @memberof ChargeInfoItems
     */
    name: string;
    /**
     * 金額
     * @type {number}
     * @memberof ChargeInfoItems
     */
    value: number;
}

/**
 * 
 * @export
 * @interface ChargeInfoSummary
 */
export interface ChargeInfoSummary {
    /**
     * 合計金額
     * @type {number}
     * @memberof ChargeInfoSummary
     */
    total: number;
    /**
     * 税額
     * @type {number}
     * @memberof ChargeInfoSummary
     */
    tax: number;
    /**
     * 税率（パーセント）
     * @type {number}
     * @memberof ChargeInfoSummary
     */
    taxRatePercent: number;
}

/**
 * 完了フラグ (1: 未完, 2: 完結済み) 
 * @export
 * @enum {string}
 */
export enum CompleteFlag {
    incompleted = 1,
    compteted = 2
}

/**
 * 確定収益情報
 * @export
 * @interface ConfirmedProfits
 */
export interface ConfirmedProfits {
    /**
     * 確定した売り上げ（受取可能金額）
     * @type {number}
     * @memberof ConfirmedProfits
     */
    confirmed: number;
    /**
     * 受取可能金額から手数料を差し引いた金額
     * @type {number}
     * @memberof ConfirmedProfits
     */
    confirmedDeductingFee: number;
}

/**
 * 
 * @export
 * @interface CreateAccountRequest
 */
export interface CreateAccountRequest {
    /**
     * ユーザープールユーザーID
     * @type {string}
     * @memberof CreateAccountRequest
     */
    cognitoUserPoolUserId: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof CreateAccountRequest
     */
    email: string;
    /**
     * 同意した利用規約のバージョン
     * @type {string}
     * @memberof CreateAccountRequest
     */
    acceptedTermsVersion?: string;
}

/**
 * 銀行口座作成リクエスト
 * @export
 * @interface CreateBankAccountRequest
 */
export interface CreateBankAccountRequest {
    /**
     * Stripeの銀行口座トークン
     * @type {string}
     * @memberof CreateBankAccountRequest
     */
    token: string;
    /**
     * 送金先のデフォルトに設定するか
     * @type {boolean}
     * @memberof CreateBankAccountRequest
     */
    defaultForCurrency: boolean;
}

/**
 * 送金履歴作成
 * @export
 * @interface CreatePayoutRequest
 */
export interface CreatePayoutRequest {
    /**
     * 申請金額
     * @type {number}
     * @memberof CreatePayoutRequest
     */
    amount?: number;
}

/**
 * Epub生成リクエスト
 * @export
 * @interface EpubGenerateRequest
 */
export interface EpubGenerateRequest {
    /**
     * ワークスペースID
     * @type {string}
     * @memberof EpubGenerateRequest
     */
    workspaceId: string;
}

/**
 * エラーコード 
 * @export
 * @enum {string}
 */
export enum ErrorCode {
    Notfound = 'notfound',
    Workspacenotfound = 'workspacenotfound',
    Illegalstate = 'illegalstate',
    Payment = 'payment',
    ValidationError = 'validation-error',
    PublishCodeError = 'publish-code-error'
}

/**
 * ワークスペース取得リクエスト
 * @export
 * @interface GetWorkspaceContentRequest
 */
export interface GetWorkspaceContentRequest {
    /**
     * メディアタイプ
     * @type {string}
     * @memberof GetWorkspaceContentRequest
     */
    contentType?: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof GetWorkspaceContentRequest
     */
    fileName?: string;
}

/**
 * 画像情報
 * @export
 * @interface ImageInfo
 */
export interface ImageInfo {
    /**
     * ファイル名
     * @type {string}
     * @memberof ImageInfo
     */
    path: string;
    /**
     * MIMEタイプ
     * @type {string}
     * @memberof ImageInfo
     */
    mimeType: string;
}

/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 退会する場合 true
     * @type {boolean}
     * @memberof InlineObject
     */
    isOk: boolean;
}

/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200
     */
    ok?: string;
}

/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2001
     */
    ok?: boolean;
}

/**
 * お知らせ一覧取得
 * @export
 * @interface ListAnnouncementResult
 */
export interface ListAnnouncementResult {
    /**
     * ネクストトークン
     * @type {string}
     * @memberof ListAnnouncementResult
     */
    nextToken?: string;
    /**
     * お知らせ一覧
     * @type {Array<Announcement>}
     * @memberof ListAnnouncementResult
     */
    items: Array<Announcement>;
}

/**
 * 著者一覧取得結果
 * @export
 * @interface ListAuthorsResult
 */
export interface ListAuthorsResult {
    /**
     * 次のトークン
     * @type {string}
     * @memberof ListAuthorsResult
     */
    nextToken?: string;
    /**
     * 取得結果
     * @type {Array<Author>}
     * @memberof ListAuthorsResult
     */
    items: Array<Author>;
}

/**
 * 銀行口座一覧取得結果
 * @export
 * @interface ListBankAccountsResult
 */
export interface ListBankAccountsResult {
    /**
     * 銀行口座一覧
     * @type {Array<BankAccount>}
     * @memberof ListBankAccountsResult
     */
    items: Array<BankAccount>;
}

/**
 * ストア毎書籍データ一覧取得レスポンス
 * @export
 * @interface ListBookPerStoreSesult
 */
export interface ListBookPerStoreSesult {
    /**
     * 一覧
     * @type {Array<BookPerStoreInfo>}
     * @memberof ListBookPerStoreSesult
     */
    items: Array<BookPerStoreInfo>;
}

/**
 * ストア一覧取得
 * @export
 * @interface ListBookStoreResult
 */
export interface ListBookStoreResult {
    /**
     * ストア一覧
     * @type {Array<BookStore>}
     * @memberof ListBookStoreResult
     */
    items: Array<BookStore>;
}

/**
 * 書籍一覧取得結果
 * @export
 * @interface ListBooksResult
 */
export interface ListBooksResult {
    /**
     * 次のトークン
     * @type {string}
     * @memberof ListBooksResult
     */
    nextToken?: string;
    /**
     * 名前
     * @type {Array<Book>}
     * @memberof ListBooksResult
     */
    items: Array<Book>;
}

/**
 * 送金履歴一覧レスポンス
 * @export
 * @interface ListPayoutResult
 */
export interface ListPayoutResult {
    /**
     * ネクストトークン
     * @type {string}
     * @memberof ListPayoutResult
     */
    nextToken?: string;
    /**
     * 結果リスト
     * @type {Array<Payout>}
     * @memberof ListPayoutResult
     */
    items: Array<Payout>;
}

/**
 * 出版ステータス一覧取得
 * @export
 * @interface ListPublishStatusTransitionsResult
 */
export interface ListPublishStatusTransitionsResult {
    /**
     * 遷移可能なステータス一覧
     * @type {Array<PublishStatus>}
     * @memberof ListPublishStatusTransitionsResult
     */
    items?: Array<PublishStatus>;
}

/**
 * カード情報
 * @export
 * @interface PaymentCard
 */
export interface PaymentCard {
    /**
     * 
     * @type {string}
     * @memberof PaymentCard
     */
    last4?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentCard
     */
    exp_month?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentCard
     */
    exp_year?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentCard
     */
    brand?: string;
}

/**
 * 支払い情報
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
    /**
     * 
     * @type {PaymentCard}
     * @memberof PaymentMethod
     */
    card?: PaymentCard;
}

/**
 * 入金情報
 * @export
 * @interface Payout
 */
export interface Payout {
    /**
     * ID
     * @type {string}
     * @memberof Payout
     */
    id: string;
    /**
     * リクエスト作成時刻
     * @type {string}
     * @memberof Payout
     */
    createTime: string;
    /**
     * 料金
     * @type {number}
     * @memberof Payout
     */
    amount: number;
    /**
     * 手数料
     * @type {number}
     * @memberof Payout
     */
    originalAmount?: number;
    /**
     * 入金日
     * @type {string}
     * @memberof Payout
     */
    arrivalDate?: string;
}

/**
 * Stripe Connectアカウントの個人情報
 * @export
 * @interface PersonalInfo
 */
export interface PersonalInfo {
    /**
     * 
     * @type {PersonalInfoBusinessType}
     * @memberof PersonalInfo
     */
    businessType?: PersonalInfoBusinessType | null;
    /**
     * 名
     * @type {string}
     * @memberof PersonalInfo
     */
    lastName?: string;
    /**
     * 姓
     * @type {string}
     * @memberof PersonalInfo
     */
    firstName?: string;
    /**
     * 名(カナ)
     * @type {string}
     * @memberof PersonalInfo
     */
    lastNameKana?: string;
    /**
     * 姓(カナ)
     * @type {string}
     * @memberof PersonalInfo
     */
    firstNameKana?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof PersonalInfo
     */
    email?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof PersonalInfo
     */
    phoneNumber?: string;
    /**
     * 
     * @type {PersonalInfoDob}
     * @memberof PersonalInfo
     */
    dob?: PersonalInfoDob | null;
    /**
     * 
     * @type {PersonalInfoConfirmationStatus}
     * @memberof PersonalInfo
     */
    confirmationStatus?: PersonalInfoConfirmationStatus;
    /**
     * 
     * @type {Address}
     * @memberof PersonalInfo
     */
    address?: Address;
    /**
     * 
     * @type {Address}
     * @memberof PersonalInfo
     */
    addressKana?: Address;
    /**
     * 
     * @type {BusinessProfile}
     * @memberof PersonalInfo
     */
    businessProfile?: BusinessProfile;
    /**
     * 入金が有効かどうか 
     * @type {boolean}
     * @memberof PersonalInfo
     */
    payoutsEnabled?: boolean;
    /**
     * 
     * @type {PersonalInfoVerification}
     * @memberof PersonalInfo
     */
    verification?: PersonalInfoVerification;
}

/**
 * ビジネスタイプ (individual: 個人, company: 企業) 
 * @export
 * @enum {string}
 */
export enum PersonalInfoBusinessType {
    individual = 'individual',
    company = 'company'
}

/**
 * 個人情報の確認ステータス 1: 確認中 2: 成功 3: 失敗 
 * @export
 * @enum {string}
 */
export enum PersonalInfoConfirmationStatus {
    processing = 1,
    succeed = 2,
    fails = 3
}

/**
 * 生年月日
 * @export
 * @interface PersonalInfoDob
 */
export interface PersonalInfoDob {
    /**
     * 年
     * @type {number}
     * @memberof PersonalInfoDob
     */
    year?: number | null;
    /**
     * 月
     * @type {number}
     * @memberof PersonalInfoDob
     */
    month?: number | null;
    /**
     * 日
     * @type {number}
     * @memberof PersonalInfoDob
     */
    day?: number | null;
}

/**
 * 検証情報
 * @export
 * @interface PersonalInfoVerification
 */
export interface PersonalInfoVerification {
    /**
     * 
     * @type {PersonalInfoVerificationDocument}
     * @memberof PersonalInfoVerification
     */
    document?: PersonalInfoVerificationDocument;
}

/**
 * 資料
 * @export
 * @interface PersonalInfoVerificationDocument
 */
export interface PersonalInfoVerificationDocument {
    /**
     * 表面
     * @type {string}
     * @memberof PersonalInfoVerificationDocument
     */
    front?: string | null;
    /**
     * 裏面
     * @type {string}
     * @memberof PersonalInfoVerificationDocument
     */
    back?: string | null;
}

/**
 * S3バケットへオブジェクトのポストデータ
 * @export
 * @interface PresignedPostData
 */
export interface PresignedPostData {
    /**
     * URL
     * @type {string}
     * @memberof PresignedPostData
     */
    url: string;
    /**
     * フィールド
     * @type {object}
     * @memberof PresignedPostData
     */
    fields: object;
    /**
     * ベースパス
     * @type {string}
     * @memberof PresignedPostData
     */
    basePath: string;
}

/**
 * 出版コード登録リクエスト
 * @export
 * @interface PublishCodeRequest
 */
export interface PublishCodeRequest {
    /**
     * 書籍ID
     * @type {string}
     * @memberof PublishCodeRequest
     */
    bookId: string;
    /**
     * 出版コード
     * @type {string}
     * @memberof PublishCodeRequest
     */
    publishCode: string;
}

/**
 * 出版情報変更依頼
 * @export
 * @interface PublishInfoModification
 */
export interface PublishInfoModification {
    /**
     * ID
     * @type {string}
     * @memberof PublishInfoModification
     */
    id: string;
    /**
     * 書籍ID
     * @type {string}
     * @memberof PublishInfoModification
     */
    bookId: string;
    /**
     * 
     * @type {PublishStatus}
     * @memberof PublishInfoModification
     */
    publishStatus?: PublishStatus;
    /**
     * タイトル
     * @type {string}
     * @memberof PublishInfoModification
     */
    title?: string;
    /**
     * タイトル(カナ)
     * @type {string}
     * @memberof PublishInfoModification
     */
    titleKana?: string;
    /**
     * タイトル(ローマ字)
     * @type {string}
     * @memberof PublishInfoModification
     */
    titleRomanAlphabet?: string;
    /**
     * サブタイトル
     * @type {string}
     * @memberof PublishInfoModification
     */
    subtitle?: string;
    /**
     * サブタイトル(かな)
     * @type {string}
     * @memberof PublishInfoModification
     */
    subtitleKana?: string;
    /**
     * サブタイトル(ローマ字)
     * @type {string}
     * @memberof PublishInfoModification
     */
    subtitleRomanAlphabet?: string;
    /**
     * シリーズタイトル
     * @type {string}
     * @memberof PublishInfoModification
     */
    seriesTitle?: string;
    /**
     * シリーズタイトル(かな)
     * @type {string}
     * @memberof PublishInfoModification
     */
    seriesTitleKana?: string;
    /**
     * シリーズタイトル(ローマ字)
     * @type {string}
     * @memberof PublishInfoModification
     */
    seriesTitleRomanAlphabet?: string;
    /**
     * 巻数
     * @type {number}
     * @memberof PublishInfoModification
     */
    numberOfVolumes?: number;
    /**
     * 説明文
     * @type {string}
     * @memberof PublishInfoModification
     */
    description?: string;
    /**
     * 著者ID
     * @type {string}
     * @memberof PublishInfoModification
     */
    authorId?: string;
    /**
     * 表紙画像のファイル名
     * @type {string}
     * @memberof PublishInfoModification
     */
    coverImage?: string;
    /**
     * 販売価格
     * @type {number}
     * @memberof PublishInfoModification
     */
    price?: number;
    /**
     * 
     * @type {Array<Category>}
     * @memberof PublishInfoModification
     */
    categoryIds?: Array<Category>;
    /**
     * プランID
     * @type {string}
     * @memberof PublishInfoModification
     */
    planId?: string;
    /**
     * ストアID
     * @type {string}
     * @memberof PublishInfoModification
     */
    storeIds?: string;
}

/**
 * 出版情報変更依頼リクエスト
 * @export
 * @interface PublishInfoModificationRequest
 */
export interface PublishInfoModificationRequest {
    /**
     * 書籍ID
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    bookId: string;
    /**
     * リクエスト毎に採番する数値
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    sequenceNumber?: string;
    /**
     * リクエスト時刻
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    requestTime?: string;
    /**
     * リクエストの状態
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    status?: string;
    /**
     * 
     * @type {PublishStatus}
     * @memberof PublishInfoModificationRequest
     */
    publishStatus: PublishStatus;
    /**
     * タイトル
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    title: string;
    /**
     * タイトル(カナ)
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    titleKana?: string;
    /**
     * タイトル(ローマ字)
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    titleRomanAlphabet?: string;
    /**
     * サブタイトル
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    subtitle?: string;
    /**
     * サブタイトル(かな)
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    subtitleKana?: string;
    /**
     * サブタイトル(ローマ字)
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    subtitleRomanAlphabet?: string;
    /**
     * シリーズタイトル
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    seriesTitle?: string;
    /**
     * シリーズタイトル(かな)
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    seriesTitleKana?: string;
    /**
     * シリーズタイトル(ローマ字)
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    seriesTitleRomanAlphabet?: string;
    /**
     * 巻数
     * @type {number}
     * @memberof PublishInfoModificationRequest
     */
    numberOfVolumes?: number;
    /**
     * 説明文
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    description?: string;
    /**
     * 著者ID
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    authorId?: string;
    /**
     * 
     * @type {Author}
     * @memberof PublishInfoModificationRequest
     */
    author?: Author;
    /**
     * 表紙画像のファイル名
     * @type {string}
     * @memberof PublishInfoModificationRequest
     */
    coverImage?: string;
    /**
     * 販売価格
     * @type {number}
     * @memberof PublishInfoModificationRequest
     */
    price?: number;
    /**
     * 
     * @type {Array<Category>}
     * @memberof PublishInfoModificationRequest
     */
    categories?: Array<Category>;
    /**
     * プランID
     * @type {number}
     * @memberof PublishInfoModificationRequest
     */
    planId?: number;
    /**
     * 
     * @type {XRated}
     * @memberof PublishInfoModificationRequest
     */
    xRated?: XRated;
    /**
     * 出版先ストア一覧
     * @type {Array<number>}
     * @memberof PublishInfoModificationRequest
     */
    storeIds?: Array<number>;
}

/**
 * 書籍出版ステータス 
 * @export
 * @enum {string}
 */
export enum PublishStatus {
    beforePayment = 0,
    beforePublish = 1,
    publishRequested = 2,
    publishing = 3,
    modificationRequestedFromUser = 4,
    modificationRequested = 5,
    suspendRequestedFromUser = 6,
    suspendRequested = 7,
    suspended = 8,
    republishRequestedFromUser = 9,
    republishRequested = 10,
    declineRequestedFromUser = 11,
    declineRequested = 12,
    declined = 13,
    rejected = 14,
    unpublishable = 15
}

/**
 * ワークスペースメタデータ取得リクエスト
 * @export
 * @interface PutWorkspaceMetaDataRequest
 */
export interface PutWorkspaceMetaDataRequest {
    /**
     * メタデータ
     * @type {object}
     * @memberof PutWorkspaceMetaDataRequest
     */
    metaData: object;
}

/**
 * 販売冊数の項目
 * @export
 * @interface QuantityItem
 */
export interface QuantityItem {
    /**
     * 販売冊数
     * @type {number}
     * @memberof QuantityItem
     */
    value: number;
    /**
     * 日時(YYYY/MM/DD)
     * @type {string}
     * @memberof QuantityItem
     */
    date: string;
}

/**
 * レポートの利益情報
 * @export
 * @interface ReportProfits
 */
export interface ReportProfits {
    /**
     * 確定した売り上げ（受取可能金額）
     * @type {number}
     * @memberof ReportProfits
     */
    confirmed: number;
    /**
     * 受取可能金額から手数料を差し引いた金額
     * @type {number}
     * @memberof ReportProfits
     */
    confirmedDeductingFee: number;
    /**
     * 販売した総売上（未確定金額を含む）
     * @type {number}
     * @memberof ReportProfits
     */
    sales: number;
}

/**
 * 販売冊数
 * @export
 * @interface ReportQuantities
 */
export interface ReportQuantities {
    /**
     * 
     * @type {Array<QuantityItem>}
     * @memberof ReportQuantities
     */
    items: Array<QuantityItem>;
}

/**
 * レポートサマリー
 * @export
 * @interface ReportSummary
 */
export interface ReportSummary {
    /**
     * 
     * @type {Array<ReportSummaryItem>}
     * @memberof ReportSummary
     */
    items: Array<ReportSummaryItem>;
    /**
     * 開始期間（yyyy/mm/dd）
     * @type {string}
     * @memberof ReportSummary
     */
    startTime?: string;
    /**
     * ネクストトークン
     * @type {string}
     * @memberof ReportSummary
     */
    nextToken?: string;
}

/**
 * レポートサマリーオブジェクト
 * @export
 * @interface ReportSummaryInfo
 */
export interface ReportSummaryInfo {
    /**
     * 売上(円)
     * @type {number}
     * @memberof ReportSummaryInfo
     */
    sales: number;
    /**
     * 販売高(円)
     * @type {number}
     * @memberof ReportSummaryInfo
     */
    revenue: number;
    /**
     * 数量
     * @type {number}
     * @memberof ReportSummaryInfo
     */
    quantity: number;
    /**
     * ストア手数料
     * @type {number}
     * @memberof ReportSummaryInfo
     */
    storeCommission: number;
    /**
     * 販売管理手数料
     * @type {number}
     * @memberof ReportSummaryInfo
     */
    commission: number;
}

/**
 * レポートサマリーの要素
 * @export
 * @interface ReportSummaryItem
 */
export interface ReportSummaryItem {
    /**
     * 日時
     * @type {string}
     * @memberof ReportSummaryItem
     */
    date: string;
    /**
     * 書籍ID
     * @type {string}
     * @memberof ReportSummaryItem
     */
    bookId: string;
    /**
     * ストアID
     * @type {number}
     * @memberof ReportSummaryItem
     */
    storeId: number;
    /**
     * 売上(円)
     * @type {number}
     * @memberof ReportSummaryItem
     */
    sales: number;
    /**
     * 販売高(円)
     * @type {number}
     * @memberof ReportSummaryItem
     */
    revenue: number;
    /**
     * 数量
     * @type {number}
     * @memberof ReportSummaryItem
     */
    quantity: number;
    /**
     * ストア手数料
     * @type {number}
     * @memberof ReportSummaryItem
     */
    storeCommission: number;
    /**
     * 販売管理手数料
     * @type {number}
     * @memberof ReportSummaryItem
     */
    commission: number;
    /**
     * ステータス
     * @type {number}
     * @memberof ReportSummaryItem
     */
    status: number;
}

/**
 * レポートサマリー
 * @export
 * @interface ReportSummaryResult
 */
export interface ReportSummaryResult {
    /**
     * 
     * @type {Array<ReportSummaryResultItem>}
     * @memberof ReportSummaryResult
     */
    items: Array<ReportSummaryResultItem>;
}

/**
 * 
 * @export
 * @interface ReportSummaryResultItem
 */
export interface ReportSummaryResultItem {
    /**
     * 
     * @type {string}
     * @memberof ReportSummaryResultItem
     */
    bookId?: string;
    /**
     * 
     * @type {ReportSummaryInfo}
     * @memberof ReportSummaryResultItem
     */
    value?: ReportSummaryInfo;
}

/**
 * 個人情報設定リクエスト
 * @export
 * @interface SetPersonalInfoRequest
 */
export interface SetPersonalInfoRequest {
    /**
     * Stripeの個人情報トークン
     * @type {string}
     * @memberof SetPersonalInfoRequest
     */
    token: string;
    /**
     * 
     * @type {BusinessProfile}
     * @memberof SetPersonalInfoRequest
     */
    businessProfile?: BusinessProfile;
}

/**
 * 区間 
 * @export
 * @enum {string}
 */
export enum Span {
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly'
}

/**
 * 
 * @export
 * @interface UpdateAccountRequest
 */
export interface UpdateAccountRequest {
    /**
     * 名前
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    name?: string;
    /**
     * 画像ファイルのパス
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    avaterImage?: string;
    /**
     * 確認済みのチュートリアルのバージョン
     * @type {number}
     * @memberof UpdateAccountRequest
     */
    confirmedTutorial?: number;
}

/**
 * 銀行口座作成リクエスト
 * @export
 * @interface UpdateBankAccountRequest
 */
export interface UpdateBankAccountRequest {
    /**
     * 銀行口座ID
     * @type {string}
     * @memberof UpdateBankAccountRequest
     */
    bankAccountId: string;
    /**
     * 送金先のデフォルトに設定するか
     * @type {boolean}
     * @memberof UpdateBankAccountRequest
     */
    defaultForCurrency: boolean;
}

/**
 * ユーザーデータのオブジェクト種別
 * @export
 * @enum {string}
 */
export enum UserDataKind {
    ProfileAvater = 'profile-avater',
    BookThumbnail = 'book-thumbnail',
    AuthorAvater = 'author-avater'
}

/**
 * 出版コード検証リクエスト
 * @export
 * @interface ValidatePublishCodeRequest
 */
export interface ValidatePublishCodeRequest {
    /**
     * 書籍ID
     * @type {string}
     * @memberof ValidatePublishCodeRequest
     */
    bookId: string;
    /**
     * 出版コード
     * @type {string}
     * @memberof ValidatePublishCodeRequest
     */
    publishCode: string;
}

/**
 * 検証エラー項目
 * @export
 * @interface ValidationErrorItem
 */
export interface ValidationErrorItem {
    /**
     * フィールド
     * @type {string}
     * @memberof ValidationErrorItem
     */
    field: string;
    /**
     * エラーメッセージ
     * @type {string}
     * @memberof ValidationErrorItem
     */
    message: string;
    /**
     * エクストラデータ
     * @type {object}
     * @memberof ValidationErrorItem
     */
    extra?: object;
}

/**
 * 検証エラー情報
 * @export
 * @interface ValidationErrors
 */
export interface ValidationErrors {
    /**
     * 
     * @type {ErrorCode}
     * @memberof ValidationErrors
     */
    code: ErrorCode;
    /**
     * メッセージ
     * @type {string}
     * @memberof ValidationErrors
     */
    message?: string;
    /**
     * 
     * @type {Array<ValidationErrorItem>}
     * @memberof ValidationErrors
     */
    errors: Array<ValidationErrorItem>;
}

/**
 * ワークスペース
 * @export
 * @interface Workspace
 */
export interface Workspace {
    /**
     * ワークスペースID
     * @type {string}
     * @memberof Workspace
     */
    id?: string;
}

/**
 * ワークスペース
 * @export
 * @interface WorkspaceContentRequest
 */
export interface WorkspaceContentRequest {
    /**
     * メディアタイプ
     * @type {string}
     * @memberof WorkspaceContentRequest
     */
    contentType?: string;
    /**
     * ファイル名
     * @type {string}
     * @memberof WorkspaceContentRequest
     */
    fileName?: string;
}

/**
 * 成人向けコンテンツかどうか
 * @export
 * @enum {string}
 */
export enum XRated {
    Yes = 'yes',
    No = 'no'
}

// ====== Models (end) ======





/**
 * APIリクエスト
 */
export class WebApi {

    /**
     * 利用規約に同意する
     * @param {AcceptTermsRequest} [acceptTermsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptTerms (
                acceptTermsRequest?: AcceptTermsRequest,
         onError?: CustomErrorHandler): WebApiResponse<InlineResponse200> {
    /*
    */
        const localVarPath = `/user/accept-terms`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = acceptTermsRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * S3バケットのオブジェクトの操作
     * @param {BucketObjectRequest} [bucketObjectRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bucketObject (
                bucketObjectRequest?: BucketObjectRequest,
         onError?: CustomErrorHandler): WebApiResponse<BucketURL> {
    /*
    */
        const localVarPath = `/user/bucket-object`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = bucketObjectRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 出版申請のための決済を実行する
     * @param {ChargeForPublishRequest} [chargeForPublishRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async chargeForPublish (
                chargeForPublishRequest?: ChargeForPublishRequest,
         onError?: CustomErrorHandler): WebApiResponse<ChargeForPublishResult> {
    /*
    */
        const localVarPath = `/user/payment/charge-for-publish`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = chargeForPublishRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * アカウント情報を登録する
     * @param {CreateAccountRequest} [createAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createAccount (
                createAccountRequest?: CreateAccountRequest,
         onError?: CustomErrorHandler): WebApiResponse<Account> {
    /*
    */
        const localVarPath = `/user/account`;
        const httpMethod = 'put'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = createAccountRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 著者情報を作成する
     * @param {AuthorCreateRequest} [authorCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createAuthor (
                authorCreateRequest?: AuthorCreateRequest,
         onError?: CustomErrorHandler): WebApiResponse<Author> {
    /*
    */
        const localVarPath = `/user/authors`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = authorCreateRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 銀行口座を登録する
     * @param {CreateBankAccountRequest} [createBankAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createBankAccount (
                createBankAccountRequest?: CreateBankAccountRequest,
         onError?: CustomErrorHandler): WebApiResponse<InlineResponse2001> {
    /*
    */
        const localVarPath = `/user/bank-accounts`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = createBankAccountRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 書籍を作成する
     * @param {BookCreateRequest} [bookCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createBook (
                bookCreateRequest?: BookCreateRequest,
         onError?: CustomErrorHandler): WebApiResponse<Book> {
    /*
    */
        const localVarPath = `/user/books`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = bookCreateRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 入金履歴を登録する
     * @param {CreatePayoutRequest} [createPayoutRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPayouts (
                createPayoutRequest?: CreatePayoutRequest,
         onError?: CustomErrorHandler): WebApiResponse<Payout> {
    /*
    */
        const localVarPath = `/user/payouts`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = createPayoutRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 本人確認情報を設定する
     * @param {SetPersonalInfoRequest} [setPersonalInfoRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPersonalInfo (
                setPersonalInfoRequest?: SetPersonalInfoRequest,
         onError?: CustomErrorHandler): WebApiResponse<InlineResponse2001> {
    /*
    */
        const localVarPath = `/user/personal-info`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = setPersonalInfoRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 出版情報変更依頼を生成する。
     * @param {PublishInfoModificationRequest} [publishInfoModificationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPublishInfoModification (
                publishInfoModificationRequest?: PublishInfoModificationRequest,
         onError?: CustomErrorHandler): WebApiResponse<ApiResult> {
    /*
    */
        const localVarPath = `/user/publish-info-modification`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = publishInfoModificationRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * ワークスペース情報を作成する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createWorkspace (
         onError?: CustomErrorHandler): WebApiResponse<Workspace> {
        const localVarPath = `/user/workspaces`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 銀行口座を削除
     * @param {string} id 銀行口座ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteBankAccount (
            {
                id,
                
            } : {
                id: string,
                
            },
         onError?: CustomErrorHandler): WebApiResponse<ApiResult> {
    /*
        // verify required parameter 'id' is not null or undefined
        assertParamExists('deleteBankAccount', 'id', id)
    */
        const localVarPath = `/user/bank-accounts`;
        const httpMethod = 'delete'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}
        /* === Query params === */
        if (id !== undefined) {
            localVarQueryParameter['id'] = id;
        }




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * EPubを生成する。
     * @param {EpubGenerateRequest} [epubGenerateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async generateEpub (
                epubGenerateRequest?: EpubGenerateRequest,
         onError?: CustomErrorHandler): WebApiResponse<BucketURL> {
    /*
    */
        const localVarPath = `/user/epub-generate`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = epubGenerateRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * アカウント情報を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAccount (
         onError?: CustomErrorHandler): WebApiResponse<Account> {
        const localVarPath = `/user/account`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 著者一覧情報を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAuthors (
         onError?: CustomErrorHandler): WebApiResponse<ListAuthorsResult> {
        const localVarPath = `/user/authors`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 書籍詳細を取得する
     * @param {string} bookId 書籍ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBook (
                bookId: string,
         onError?: CustomErrorHandler): WebApiResponse<Book> {
    /*
        // verify required parameter 'bookId' is not null or undefined
        assertParamExists('getBook', 'bookId', bookId)
    */
        const localVarPath = `/user/books/{bookId}`
            .replace(`{${"bookId"}}`, encodeURIComponent(String(bookId)));
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 書籍に対する課金情報を取得する。
     * @param {string} [bookId] 書籍ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getChargeInfo (
            {
                bookId,
                
            } : {
                bookId?: string,
                
            },
         onError?: CustomErrorHandler): WebApiResponse<ChargeInfo> {
    /*
    */
        const localVarPath = `/user/payment/charge-info`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}
        /* === Query params === */
        if (bookId !== undefined) {
            localVarQueryParameter['bookId'] = bookId;
        }




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 確定利益取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConfirmedProfits (
         onError?: CustomErrorHandler): WebApiResponse<ConfirmedProfits> {
        const localVarPath = `/user/reports/confirmed-profits`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 日時レポート取得
     * @param {Span} span 期間（日次/月次）
     * @param {boolean} aggregateByDate 日付毎のデータ
     * @param {string} [bookId] 対象の書籍ID
     * @param {string} [startTime] 開始の日時 span &#x3D; daily の場合： \&#39;YYYY-MM-DD\&#39; span &#x3D; montyly の場合： \&#39;YYYY-MM\&#39; 
     * @param {string} [endTime] 終了の日時 span &#x3D; daily の場合： \&#39;YYYY-MM-DD\&#39; span &#x3D; montyly の場合： \&#39;YYYY-MM\&#39; 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDailyReports (
            {
                span,bookId,startTime,endTime,aggregateByDate,
                
            } : {
                span: Span,bookId?: string,startTime?: string,endTime?: string,aggregateByDate: boolean,
                
            },
         onError?: CustomErrorHandler): WebApiResponse<ReportSummary> {
    /*
        // verify required parameter 'span' is not null or undefined
        assertParamExists('getDailyReports', 'span', span)
    */
    /*
        // verify required parameter 'aggregateByDate' is not null or undefined
        assertParamExists('getDailyReports', 'aggregateByDate', aggregateByDate)
    */
    /*
    */
    /*
    */
    /*
    */
        const localVarPath = `/user/reports/daily`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}
        /* === Query params === */
        if (span !== undefined) {
            localVarQueryParameter['span'] = span;
        }
        /* === Query params === */
        if (bookId !== undefined) {
            localVarQueryParameter['bookId'] = bookId;
        }
        /* === Query params === */
        if (startTime !== undefined) {
            localVarQueryParameter['startTime'] = startTime;
        }
        /* === Query params === */
        if (endTime !== undefined) {
            localVarQueryParameter['endTime'] = endTime;
        }
        /* === Query params === */
        if (aggregateByDate !== undefined) {
            localVarQueryParameter['aggregateByDate'] = aggregateByDate;
        }




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 支払い情報を取得するする。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPaymentMethod (
         onError?: CustomErrorHandler): WebApiResponse<PaymentMethod> {
        const localVarPath = `/user/payment/method`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 本人確認情報を取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPersonalInfo (
         onError?: CustomErrorHandler): WebApiResponse<PersonalInfo> {
        const localVarPath = `/user/personal-info`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 利益取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReportProfits (
         onError?: CustomErrorHandler): WebApiResponse<ReportProfits> {
        const localVarPath = `/user/reports/profits`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 販売冊数リスト取得
     * @param {number} [days] 取得日数（本日から遡ったN日前）
     * @param {string} [bookId] 書籍ID, 未指定の場合はアカウント内の全書籍を対象
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReportQuantities (
            {
                days,bookId,
                
            } : {
                days?: number,bookId?: string,
                
            },
         onError?: CustomErrorHandler): WebApiResponse<ReportQuantities> {
    /*
    */
    /*
    */
        const localVarPath = `/user/reports/quantities`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}
        /* === Query params === */
        if (days !== undefined) {
            localVarQueryParameter['days'] = days;
        }
        /* === Query params === */
        if (bookId !== undefined) {
            localVarQueryParameter['bookId'] = bookId;
        }




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * レポートサマリー取得
     * @param {string} [bookId] 対象の書籍ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSummaryReports (
            {
                bookId,
                
            } : {
                bookId?: string,
                
            },
         onError?: CustomErrorHandler): WebApiResponse<ReportSummaryResult> {
    /*
    */
        const localVarPath = `/user/reports/summary`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}
        /* === Query params === */
        if (bookId !== undefined) {
            localVarQueryParameter['bookId'] = bookId;
        }




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * ワークスペースコンテンツを取得する
     * @param {string} workspaceId ワークスペースID
     * @param {Array<string>} fileNames ファイル名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWorkspaceContents (
            {
                fileNames,
                workspaceId,
            } : {
                fileNames: Array<string>,
                workspaceId: string,
            },
         onError?: CustomErrorHandler): WebApiResponse<Array<BucketURL>> {
    /*
        // verify required parameter 'workspaceId' is not null or undefined
        assertParamExists('getWorkspaceContents', 'workspaceId', workspaceId)
    */
    /*
        // verify required parameter 'fileNames' is not null or undefined
        assertParamExists('getWorkspaceContents', 'fileNames', fileNames)
    */
        const localVarPath = `/user/workspaces/{workspaceId}/contents`
            .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}
        /* === Query params === */
        if (fileNames) {
            localVarQueryParameter['fileNames'] = fileNames;
        }




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * ワークスペースメタデータを取得する
     * @param {string} workspaceId ワークスペースID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWorkspaceMetaData (
                workspaceId: string,
         onError?: CustomErrorHandler): WebApiResponse<object> {
    /*
        // verify required parameter 'workspaceId' is not null or undefined
        assertParamExists('getWorkspaceMetaData', 'workspaceId', workspaceId)
    */
        const localVarPath = `/user/workspaces/{workspaceId}/meta`
            .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * お知らせ一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listAnnouncement (
         onError?: CustomErrorHandler): WebApiResponse<ListAnnouncementResult> {
        const localVarPath = `/user/announcements`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 銀行口座を取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listBankAccounts (
         onError?: CustomErrorHandler): WebApiResponse<ListBankAccountsResult> {
        const localVarPath = `/user/bank-accounts`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * ストア毎の書籍詳細情報を取得する
     * @param {string} bookId 書籍ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listBookPerStore (
                bookId: string,
         onError?: CustomErrorHandler): WebApiResponse<ListBookPerStoreSesult> {
    /*
        // verify required parameter 'bookId' is not null or undefined
        assertParamExists('listBookPerStore', 'bookId', bookId)
    */
        const localVarPath = `/user/books-per-stores/{bookId}`
            .replace(`{${"bookId"}}`, encodeURIComponent(String(bookId)));
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * サイトのストア情報一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listBookStores (
         onError?: CustomErrorHandler): WebApiResponse<ListBookStoreResult> {
        const localVarPath = `/user/book-stores`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 書籍一覧を取得する
     * @param {string} [nextToken] ネクストトークン
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listBooks (
            {
                nextToken,
                
            } : {
                nextToken?: string,
                
            },
         onError?: CustomErrorHandler): WebApiResponse<ListBooksResult> {
    /*
    */
        const localVarPath = `/user/books`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}
        /* === Query params === */
        if (nextToken !== undefined) {
            localVarQueryParameter['nextToken'] = nextToken;
        }




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 漫画カテゴリ一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCategoriesComic (
         onError?: CustomErrorHandler): WebApiResponse<CategoryComicResult> {
        const localVarPath = `/user/categories/comic`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * カテゴリ一覧を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCategoriesTree (
         onError?: CustomErrorHandler): WebApiResponse<CategoryTreeResult> {
        const localVarPath = `/user/categories/tree`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 入金履歴一覧取得
     * @param {string} [nextToken] ネクストトークン
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listPayouts (
            {
                nextToken,
                
            } : {
                nextToken?: string,
                
            },
         onError?: CustomErrorHandler): WebApiResponse<ListPayoutResult> {
    /*
    */
        const localVarPath = `/user/payouts`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}
        /* === Query params === */
        if (nextToken !== undefined) {
            localVarQueryParameter['nextToken'] = nextToken;
        }




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * （管理ツール）書籍ステータスの遷移可能リストを取得する
     * @param {PublishStatus} publishStatus 書籍出版ステータス
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listStatusTransitions (
            {
                publishStatus,
                
            } : {
                publishStatus: PublishStatus,
                
            },
         onError?: CustomErrorHandler): WebApiResponse<ListPublishStatusTransitionsResult> {
    /*
        // verify required parameter 'publishStatus' is not null or undefined
        assertParamExists('listStatusTransitions', 'publishStatus', publishStatus)
    */
        const localVarPath = `/user/publish-status-transitions`;
        const httpMethod = 'get'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}
        /* === Query params === */
        if (publishStatus !== undefined) {
            localVarQueryParameter['publishStatus'] = publishStatus;
        }




        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 出版コードを登録する。
     * @param {PublishCodeRequest} [publishCodeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publishByCode (
                publishCodeRequest?: PublishCodeRequest,
         onError?: CustomErrorHandler): WebApiResponse<ApiResult> {
    /*
    */
        const localVarPath = `/user/publish-by-code`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = publishCodeRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * ワークスペースメタデータを登録する
     * @param {string} workspaceId ワークスペースID
     * @param {PutWorkspaceMetaDataRequest} [putWorkspaceMetaDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putWorkspaceMetaData (
                workspaceId: string,
                putWorkspaceMetaDataRequest?: PutWorkspaceMetaDataRequest,
         onError?: CustomErrorHandler): WebApiResponse<object> {
    /*
        // verify required parameter 'workspaceId' is not null or undefined
        assertParamExists('putWorkspaceMetaData', 'workspaceId', workspaceId)
    */
    /*
    */
        const localVarPath = `/user/workspaces/{workspaceId}/meta`
            .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
        const httpMethod = 'put'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = putWorkspaceMetaDataRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 退会する
     * @param {InlineObject} [inlineObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unregister (
                inlineObject?: InlineObject,
         onError?: CustomErrorHandler): WebApiResponse<string> {
    /*
    */
        const localVarPath = `/user/unregister`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = inlineObject

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * アカウント情報を更新する
     * @param {UpdateAccountRequest} [updateAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAccount (
                updateAccountRequest?: UpdateAccountRequest,
         onError?: CustomErrorHandler): WebApiResponse<Account> {
    /*
    */
        const localVarPath = `/user/account`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = updateAccountRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 著者情報を更新する
     * @param {string} authorId 著者ID
     * @param {AuthorCreateRequest} [authorCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAuthor (
                authorId: string,
                authorCreateRequest?: AuthorCreateRequest,
         onError?: CustomErrorHandler): WebApiResponse<Author> {
    /*
        // verify required parameter 'authorId' is not null or undefined
        assertParamExists('updateAuthor', 'authorId', authorId)
    */
    /*
    */
        const localVarPath = `/user/authors/{authorId}`
            .replace(`{${"authorId"}}`, encodeURIComponent(String(authorId)));
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = authorCreateRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 銀行口座を更新する
     * @param {UpdateBankAccountRequest} [updateBankAccountRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBankAccount (
                updateBankAccountRequest?: UpdateBankAccountRequest,
         onError?: CustomErrorHandler): WebApiResponse<ApiResult> {
    /*
    */
        const localVarPath = `/user/bank-accounts`;
        const httpMethod = 'put'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = updateBankAccountRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 本人確認情報を更新する
     * @param {SetPersonalInfoRequest} [setPersonalInfoRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePersonalInfo (
                setPersonalInfoRequest?: SetPersonalInfoRequest,
         onError?: CustomErrorHandler): WebApiResponse<InlineResponse2001> {
    /*
    */
        const localVarPath = `/user/personal-info`;
        const httpMethod = 'put'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = setPersonalInfoRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * ワークスペースコンテンツをアップロードする(アップロードURLを発行する)
     * @param {string} workspaceId ワークスペースID
     * @param {WorkspaceContentRequest} [workspaceContentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadWorkspaceContents (
                workspaceId: string,
                workspaceContentRequest?: WorkspaceContentRequest,
         onError?: CustomErrorHandler): WebApiResponse<PresignedPostData> {
    /*
        // verify required parameter 'workspaceId' is not null or undefined
        assertParamExists('uploadWorkspaceContents', 'workspaceId', workspaceId)
    */
    /*
    */
        const localVarPath = `/user/workspaces/{workspaceId}/contents`
            .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = workspaceContentRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }
    /**
     * 出版コードを検証する
     * @param {ValidatePublishCodeRequest} [validatePublishCodeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async validatePublishCode (
                validatePublishCodeRequest?: ValidatePublishCodeRequest,
         onError?: CustomErrorHandler): WebApiResponse<ApiResult> {
    /*
    */
        const localVarPath = `/user/publish-code/validate`;
        const httpMethod = 'post'

        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // Parameter
        const params: { [key: string]: any } = {}


            localVarHeaderParameter['Content-Type'] = 'application/json';



        params.body = validatePublishCodeRequest

        const response: any = await _apiRequest({
            httpMethod,
            params,
            localVarHeaderParameter,
            localVarQueryParameter,
            localVarPath,
            onError
        });

        return response;
    }

};






// ====== Utility ======

/**
 * APIリクエスト
 */
async function _apiRequest(request: ApiRequestOptions) {
    const apis = {
        get: (apiName: any, path: any, init: any) => API.get(apiName, path, init),
        post:  (apiName: any, path: any, init: any) => API.post(apiName, path, init),
        put: (apiName: any, path: any, init: any) => API.put(apiName, path, init),
        delete: (apiName: any, path: any, init: any) => API.del(apiName, path, init),
    }

    let result;
    try {
        const api = apis[request.httpMethod];
        
        result = await api('Default', request.localVarPath, {
            queryStringParameters: request.localVarQueryParameter,
            body: request.params.body
        });
        return { result, isSuccess: true }
    } catch (error: any) {
        let globlError = true;
        if (request.onError) {
            const obj = {
                consume: () => { globlError = false; },
                ...error,
            }
            request.onError(obj);
        }
        if (globlError && _onError) {
            _onError(error);
        }
        return { error, isSuccess: false }
    }
}

interface ApiRequestOptions {
    httpMethod: 'get' | 'post' | 'put' | 'delete'
    [p: string]: any,
    localVarPath: string,
    onError?: CustomErrorHandler,
}

/**
 * Web APIのレスポンス
 */
export type WebApiResponse<T> = Promise<Success<T> | Failure>

/**
 * 成功 
 */
export type Success<T> = {
    result: T,
    isSuccess: true,
    error: undefined,
}

/**
 * 失敗
*/
type Failure = {
    result: undefined,
    error: CommonApiError,
    isSuccess: false,
}

/* APIエラー */
export type CommonApiError = {
    /** エラーを消費してグローバルハンドラに流れないようにする。 */
    consume(): void;
    /** エラーレスポンス */
    response: {
        /** エラーデータ */
        data: {
            code: string,
            /** エラーコード */
            errorCode: number,
            /** エラーメッセージ */
            message: string,
        },
        /** ステータスコード */
        status: number,
        statusText: string
    }
}


/** エラーイベントハンドラー */
type OnError = (error: CommonApiError) => void

/**
 * エラーハンドラー
 */
let _onError: OnError | undefined;

/**
 * APIのグローバルエラーハンドラーを設定する。
 */
export const setGlobalErrorHandler = (error: OnError) => {
    _onError = error;
}

/** 
 * カスタムエラーハンドラー
 * @param error エラー
 */
export type CustomErrorHandler = (error: CommonApiError) => void